import React from 'react';
import { Icon } from '@noths/polaris-design-system-core-components';

import * as styles from './PartnerDetails.styles';

export interface PartnerDetailsProps {
  linkHref: string;
  location: string;
  logoSrc: string;
  name: string;
  onLinkClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const PartnerDetails = ({
  linkHref,
  location,
  logoSrc,
  name,
  onLinkClick,
}: PartnerDetailsProps) => (
  <div css={styles.root}>
    <img alt={name} css={styles.logo} src={logoSrc} />
    <div css={styles.body}>
      {linkHref ? (
        <p css={styles.soldBy}>
          Sold by{' '}
          <a css={styles.link} href={linkHref} onClick={onLinkClick}>
            <strong>{name}</strong>
            <Icon name="actionForward" size="sm" />
          </a>
        </p>
      ) : (
        <p css={styles.partnerName}>
          <strong>{name}</strong>
        </p>
      )}
      {location && (
        <p css={styles.location}>
          <Icon name="location" size="sm" />
          {location}
        </p>
      )}
    </div>
  </div>
);
